import { buildStylePropFn } from '../buildStyleFns';
import { borderColorFns, borderColorStyleFnConfigs } from './color';
import { borderLineStyleFns, borderLineStyleFnConfigs } from './lineStyle';
import { borderRadiusFns, borderRadiusStyleFnConfigs } from './radius';
import { borderShorthandFns, borderShorthandStyleFnConfigs, } from './shorthand';
import { borderWidthFns, borderWidthStyleFnConfigs } from './width';
/**
 * A style prop function that takes component props and returns border styles. Some props, such as borderRadius and borderColor, are connected to our design tokens.
 * If no `BorderStyleProps` are found, it returns an empty object.
 *
 * @example
 * ```tsx
 * const BorderExample = () => (
 *   <Box
 *    border="solid 1px"
 *    borderColor="soap500"
 *    borderRadius="l"
 *   >
 *     Hello, border styles!
 *   </Box>
 * );
 *```
 */
export const border = buildStylePropFn({
    ...borderColorFns,
    ...borderLineStyleFns,
    ...borderRadiusFns,
    ...borderShorthandFns,
    ...borderWidthFns,
});
export const borderStyleFnConfigs = [
    ...borderColorStyleFnConfigs,
    ...borderLineStyleFnConfigs,
    ...borderRadiusStyleFnConfigs,
    ...borderShorthandStyleFnConfigs,
    ...borderWidthStyleFnConfigs,
];
